import {
 
  GET_BLOGS,GET_BLOGS_FAIL,GET_BLOGS_SUCCESS,
  GET_BLOGS_BY_SLUG,GET_BLOGS_BY_SLUG_FAIL,GET_BLOGS_BY_SLUG_SUCCESS

} from "./actionTypes"


/* Get Customer */
export const getBlogs = (id) => ({
  type: GET_BLOGS,
  payload: id,
})

export const getBlogsFail = (error) => ({
  type: GET_BLOGS_FAIL,
  payload: error,
})

export const getBlogsSuccess = (data) => ({
  type: GET_BLOGS_SUCCESS,
  payload: data,
})


export const getBlogsBySlug = (data, callback) => ({
  type: GET_BLOGS_BY_SLUG,
  payload: {data, callback},
});


export const getBlogsBySlugFail = (error) => ({
  type: GET_BLOGS_BY_SLUG_FAIL,
  payload: error,
})

export const getBlogsBySlugSuccess = (data) => ({
  type: GET_BLOGS_BY_SLUG_SUCCESS,
  payload: data,
})



